import { MenuButton, MenuContainer } from './styled';
import { useHistory } from 'react-router-dom';

export const DesktopMenu = ({ setOpenMyProfile, openMyProfile }) => {
  const { push } = useHistory();
  const logout = e => {
    e.preventDefault();

    push('/logout');
    return null;
  };

  const goToLeankeep = () => {
    window.open(
      `${process.env.REACT_APP_LEGADO}/Anomalias/ShowAnomaliasTablePage.aspx`,
      '_blank',
      'noopener,noreferrer',
    );
  };
  return (
    <>
      <MenuContainer>
        <MenuButton Width={'9%'} onClick={() => setOpenMyProfile(false)}>
          inicio
        </MenuButton>
        <MenuButton Width={'36%'} onClick={goToLeankeep}>
          Acessar versão antiga
        </MenuButton>
        <MenuButton Width={'16%'} onClick={() => setOpenMyProfile(!openMyProfile)}>
          meu perfil
        </MenuButton>
        <MenuButton onClick={e => logout(e)} Width={'6%'}>
          sair
        </MenuButton>
      </MenuContainer>
    </>
  );
};
